<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="isNew" i18n="create contact form title|The title of the contact form modal when a new contact is being created@@newContactFormTitle">New Contact</span>
    <span *ngIf="!isNew" i18n="edit contact form title|The title of the contact form modal when a previous contact is being edited is being created@@editContactFormTitle">Edit Contact</span>
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="onCancelClick()">
      <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <input type="hidden" class="form-control id-contact hidden" formControlName="idContact" />
    <div class="row">
      <div class="form-group name col-md-4 col-xs-12">
        <label i18n="contact form name label|The label for the name input of the contact at the contact form modal@@contactFormNameLabel">Name*</label>
        <input type="text" class="form-control" formControlName="name" />
      </div>
      <div class="form-group email col-md-5 col-xs-12">
        <label i18n="contact form email label|The label for the email input of the contact at the contact form modal@@contactFormEmailLabel">Email*</label>
        <input type="text" class="form-control" formControlName="email" />
      </div>
      <div class="form-group phone col-md-3 col-xs-12">
        <label i18n="contact form phone label|The label for the phone input of the contact at the contact form modal@@contactFormPhoneLabel">Phone</label>
        <input type="text" class="form-control" formControlName="phone" />
      </div>
    </div>
    <div class="row">
      <div class="form-group title col-md-4 col-xs-12">
        <label i18n="contact form title label|The label for the title input of the contact at the contact form modal@@contactFormTitleLabel">Title</label>
        <input type="text" class="form-control" formControlName="title" />
      </div>
      <div class="form-group company col-md-5 col-xs-12">
        <label i18n="contact form company label|The label for the company input of the contact at the contact form modal@@contactFormCompanyLabel">Company</label>
        <input type="text" class="form-control" formControlName="company" />
      </div>
      <div class="form-group department col-md-3 col-xs-12">
        <label i18n="contact form department label|The label for the department input of the contact at the contact form modal@@contactFormDepartmentLabel">Department</label>
        <input type="text" class="form-control" formControlName="department" />
      </div>
    </div>
    <div class="row tags">
      <div class="form-group col-md-12 col-xs-12">
        <label>Tags</label>
        <div class="tag-input-row">
          <tag-input
            formControlName="tags"
            style="width: 100%"
            [trimTags]="true"
            [separatorKeys]="[' ', '\n']"
          >
          <tag-input-dropdown [autocompleteItems]="availableTags" [appendToBody]="false"></tag-input-dropdown>
        </tag-input>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="form-group is-password-enabled col-md-3 col-xs-12">
        <label i18n="contact form pdf password label|The label for the selector to choose whether pdf password is active or not at the contact form modal@@contactPdfPasswordEnabledLabel">Password on PDFs</label>
        <input type="hidden" class="form-control" formControlName="isPasswordEnabled" />
        <div class="btn-group btn-group-justified">
          <div class="btn-group">
            <button
              type="button"
              [ngClass]="{'btn': true, 'btn-default': !isEnabledPassword, 'btn-info': isEnabledPassword, 'disabled': isEnabledPassword}"
              (click)="onPasswordSwitch(true)"
              i18n="Yes label to indicate that something is actived, enabled or positive@@Yes"
            >Yes</button>
          </div>
          <div class="btn-group">
            <button
              type="button"
              [ngClass]="{'btn': true, 'btn-default': isEnabledPassword, 'btn-info': !isEnabledPassword, 'disabled': !isEnabledPassword}"
              (click)="onPasswordSwitch(false)"
              i18n="No label to indicate that something is deactived, disabled or negative@@No"
            >No</button>
          </div>
        </div>
      </div>
      <div class="form-group pdf-password col-md-3 col-xs-12">
        <label i18n="contact form pdf password label|The label for the PDF password input of the contact at the contact form modal@@contactFormPdfPasswordLabel">Pdf Password</label>
        <input
          type="text"
          class="form-control"
          formControlName="pdfpassword"
          [readonly]="!isEnabledPassword"
        />
      </div>
      <div class="form-group pass-gen col-md-3 col-xs-12">
        <label i18n="auto generate password button title label|The title of the contact form section that contains a button to generate a PDF password for the contact that is currently being edited@@autoGeneratePasswordButtonTitle">Auto Generate Password</label>
        <button
          type="button"
          class="btn btn-info btn-block"
          (click)="onGeneratePasswordClick()"
          i18n="auto generate password button label|The label at the generate PDF password button for the contact that is currently being edited@@autoGeneratePasswordButtonLabel"
        >Generate</button>
      </div>
      <div class="form-group pass-gen col-md-3 col-xs-12">
        <label i18n="send pdf password button title|The title of the contact form section that contains a button to send the PDF password to the contact that is currently being edited@@sendPdfPasswordButtonTitle">Send Email with Password</label>
        <button
          type="button"
          class="btn btn-info btn-block btn-with-left-icon"
          (click)="onSendEmailWithPasswordClick()"
          [disabled]="sendingEmailWithPassword && isEnabledPassword"
        >
          <span class="sent-icon" *ngIf="sentPdfPassword === form.get('pdfpassword').value">
            <i *ngIf="sentPdfPassword === form.get('pdfpassword').value" class="fa fa-check"></i>
          </span>
          <span class="not-sent-icon" *ngIf="sentPdfPassword !== form.get('pdfpassword').value">
            <i *ngIf="!sendingEmailWithPassword" class="fa fa-rocket"></i>
            <i *ngIf="sendingEmailWithPassword" class="fa fa-circle-o-notch fa-spin"></i>
          </span>
          <span class="sent-label" *ngIf="sentPdfPassword === form.get('pdfpassword').value">
            <span
              i18n="send pdf password button state sent|The label at the send PDF password button for the contact that is currently being edited after the button has been clicked and the email successfully sent@@sendPdfPasswordButtonStateSent"
            >Sent!</span>
          </span>
          <span class="not-sent-label" *ngIf="sentPdfPassword !== form.get('pdfpassword').value">
            <span
              *ngIf="!sendingEmailWithPassword"
              i18n="send pdf password button label|The label at the send PDF password button for the contact that is currently being edited@@sendPdfPasswordStateSent"
            >Send</span>
            <span
              *ngIf="sendingEmailWithPassword"
              i18n="send pdf password button state sending|The label at the send PDF password button for the contact that is currently being edited after the button has been clicked and the email currently being sent@@sendPdfPasswordButtonStateSending"
            >Sending</span>
          </span>
        </button>
      </div>
    </div>
    <div class="row error-list" *ngIf="errors.length > 0 && (this.form.invalid || forceShowError)">
      <div class="col-md-12 col-xs-12">
        <ul class="alert alert-danger">
          <li
            *ngIf="errors.length === 1 && forceShowError && !isNew"
            i18n="contact form error unknown server message indication|The error message for the contact form shown when there was a single server error while updating the contact@@contactFormErrorMessage"
          >There was an error while trying to update the contact</li>
          <li
            *ngIf="errors.length === 1 && forceShowError && isNew"
            i18n="contact form error unknown server message indication|The error message for the contact form shown when there was a single server error while creating the contact@@contactFormErrorMessage"
          >There was an error while trying to create the contact</li>
          <li
            *ngIf="errors.length === 1 && !forceShowError"
            i18n="contact form singular error message indication|The error message for the contact form shown when there was a single validation error while saving the contact@@contactFormErrorMessage"
          >There is an error in the form</li>
          <li
            *ngIf="errors.length > 1"
            i18n="contact form multiple error message indication|The error message for the contact form shown when there was ultiple validation error while saving the contact@@contactFormErrorMessage"
          >There are errors in the form:</li>
          <li *ngFor="let error of errors">{{ error }}</li>
        </ul>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <span class="required-fields" i18n="The text at the end of the form that indicates that asterisks mean the field is required@@defineAstericRequiredFields">* Required fields</span>
  <button type="button" class="btn btn-outline-dark" (click)="onCancelClick()">
    <span i18n="cancel changes contact action|The label of the button used to close the contact form, cancelling changes if they were made, at the contact form modal@@cancelChangesContactAction">Close</span>
  </button>
  <button type="button" class="btn btn-primary" (click)="onSubmitClick()">
    <span i18n="create contact final main action|The label of the button used to finish the creation of a contact at the contact form modal@@newContactFinalActionLabel" *ngIf="isNew">Create</span>
    <span i18n="update contact final main action|The label of the button used to finish the edition of a previously created contact at the contact form modal@@updateContactFinalActionLabel" *ngIf="!isNew">Update</span>
  </button>
</div>
